

import { useSnackbar } from 'notistack';

import { useRecoilValue } from 'recoil';

import useAxios from 'library/axios'; 
import { useEffect, useState } from 'react';
import { IPhysicalInventory, IPhysicalInventorySearch } from "../models/PhysicalInventory";
import { useTranslation  } from 'react-i18next';
import { IPagination, ITextFilterElement } from 'components/ui/BasicTextFilterForm';
import { IResult } from 'library/interface';
import { HeadCell, RowCheckedMode } from 'components/ui/EnhancedTable';

import { currentUserSessionAtom } from 'library/store';
import { isNumber, toNumber } from 'lodash';
import { useQuery } from 'react-query';
import { ISchoolYear } from 'features/setup/models/SchoolYear';


const _ = () => {

    const axios = useAxios(); 

    //const {schoolYears} = useRecoilValue(currentUserSessionAtom);    

    const createPhysicalInventory = async (physicalInventory: IPhysicalInventory)  =>       
        await (await axios.post('/api/configuration/physicalInventory/create', physicalInventory)).data;       
        
    const updatePhysicalInventory = async (physicalInventory: IPhysicalInventory)  =>       
        await (await axios.post('/api/configuration/physicalInventory/update', physicalInventory)).data; 
    
    const getPhysicalInventory = async (id  : number )  => {
      const {data} = (await axios.get(`/api/configuration/physicalInventory/get-physicalInventory/${id}`));
      return await data;
    }
   
    const getPhysicalInventories = async (criteria: IPhysicalInventorySearch, pagination?: IPagination) : Promise<IPhysicalInventory[]> => {

      const {reference, description } = criteria;

      const pageSize = pagination?.pageSize ?? 50;
      const pageNumber = pagination?.pageNumber ?? 1;

      const {data} = (await axios.get(`/api/configuration/physicalInventory/get-physicalInventories?reference=${reference}&description=${description}` +
          `&pageSize=${pageSize}&pageNumber=${pageNumber}`));
          
      return await data;
    }

      
    return {    
      createPhysicalInventory,
      updatePhysicalInventory,
      getPhysicalInventory,
      getPhysicalInventories,
      
    } 
}

export default _;

export interface IFilterPhysicalInventoryOption {
  rowCheckedMode: RowCheckedMode,
  stateSelected?: [number[], React.Dispatch<React.SetStateAction<number[]>>],
  stateFiltered?: [IPhysicalInventory[], React.Dispatch<React.SetStateAction<IPhysicalInventory[]>>],
}

const defaultFilterPhysicalInventoryOption: IFilterPhysicalInventoryOption = {
  rowCheckedMode: 'single'
  //stateSelected: navigate
}


export const useBasicFilterPhysicalInventory = (  onRowDoubleClick: (event: React.MouseEvent<unknown>, row: IPhysicalInventory) => void,
                    filterOption?: IFilterPhysicalInventoryOption  ) => {

  const { getPhysicalInventories } = _();

  const { t, i18n } = useTranslation();   

  const { applicationSetup } = useRecoilValue(currentUserSessionAtom);

  const {rowCheckedMode, stateSelected, stateFiltered} = filterOption || defaultFilterPhysicalInventoryOption;

  //const {data: schoolYears} = useQuery<ISchoolYear[]>( ['SchoolYears'], () => getSchoolYears( {year: 0, name: ''}) );

  const [headPhysicalInventoryCells, setHeadPhysicalInventoryCells]  = useState<HeadCell<IPhysicalInventory>[]>([
    {id:'id', label : t('Id'),  display: true, type: 'numeric', width: 5 },    
    {id:'reference', label : t('Reference'),  display: true, type: 'string', width: 20 },
    {id:'description', label : t('Description'),  display: true, type: 'string', width: 20},

    {id:'issueDate', label : t('Date'),  display: true, type: 'date', width: 10},
    {id:'status', label : t('Status'),  display: true, type: 'string', width: 15},


  ]); 
  
  const [filterElements,setFilterElements] = useState<ITextFilterElement[]>([         
       
    {name: 'reference', text: t('Reference'), value: ''},
    {name: 'description', text: t('Description'), value: ''},
           
  ]);
  
  const [filteredDeliveries, ] = useState<IPhysicalInventory[]>([]); 

  const onFilterButtonClick = async (filterElements: ITextFilterElement[], pagination?: IPagination) : Promise<IPhysicalInventory[]> => {
    
    const reference = filterElements.find( elt => elt.name === 'reference')?.value || '';
    const description = filterElements.find( elt => elt.name === 'description')?.value || '';
    
    const arr = await getPhysicalInventories( {reference, description}, pagination );
   
    return arr;
  }

  const objKey: keyof IPhysicalInventory = 'id';

  return {
    title: `${t('Physical inventory')}(s)`, headCells: headPhysicalInventoryCells, objKey,
    filterElements, rows: filteredDeliveries, 
    onFilterButtonClick, onRowDoubleClick, rowCheckedMode, stateSelected, stateFiltered
  }
}
